<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="dialogVisible"
        center
        class="detail-dialog-container"
        width="555px">
        <div class="dialog-container flex flex-direction ">
            <img class="watermark" src="../assets/img/dialog_bg_1.png">
            <div class="dialog-content flex flex-direction">
                <div class="dialog-operate flex align-center justify-end">
                    <i class="close el-icon-close margin-left-xs" @click="cancel(false)"></i>
                </div>
                <div class="title self-center margin-tb">是否去设置会员<span>自定义字段</span>信息?</div>
                <div class="tips-container">
                    <div class="name">默认字段</div>
                    <template v-if="type === 1">
                        <div class="classify margin-lr-xs margin-top-xs">个人会员：</div>
                        <div class="content margin-lr-xs">机构所属协会/分支机构、会员姓名、会员等级、会员电话、工作单位</div>
                    </template>
                    <template v-else>
                        <div class="classify margin-lr-xs margin-top-xs">单位会员：</div>
                        <div class="content margin-lr-xs">所属协会/分支机构、单位名称、社会统一信用代码、单位性质、会员等级、法人联系电话、法人姓名、联系人姓名、联系人电话、单位地址</div>
                    </template>
                </div>
                <div class="operate-container flex align-center justify-center margin-tb">
                    <div class="operate" @click="useSet">使用默认</div>
                    <div class="operate yellow" @click="toSet">去自定义</div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>

import {baseURL} from "@/config";

export default {
    components: {},
    name: "ImportDownDialog",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        type: { // 会员类型 1 个人 2 单位
            type: [Number, String],
            default: 1
        },
    },
    data() {
        return {}
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
    },
    methods: {
        async init() {

        },
        useSet() {
            this.$emit('watchState', true)
            window.open(baseURL + `Admin/${this.type === 1 ? 'Personal' : 'User'}/exportUserTemplate?mid=` + this.user.mid + '&sign=' + this.user.sign)
        },
        toSet() {
            this.$emit('watchState', false)
            this.$router.push(`/organization/setup/${this.type === 1 ? 'sinformation' : 'information'}`)
        },
        cancel() {
            this.$emit('watchState', false)
        },

    },
    watch: {
        dialogVisible() {

        },
    }
}
</script>

<style lang="scss" scoped>
.detail-dialog-container {
    .dialog-container {
        position: relative;
        background-image: linear-gradient(0deg,#ffffff 1%,  #ffdcba 100%),
        linear-gradient( #ffffff, #ffffff);
        background-blend-mode: normal, normal;
        padding: 13px 20px;
        border-radius: 10px;
        .watermark {
            width: 100%;
            right: 0;
            top: 0;
            position: absolute;
        }
        .close {
            font-size: 16px;
            color: #0a2240;
            cursor: pointer;
        }
        .dialog-content {
            z-index: 1;
            .title {
                font-size: 20px;
                font-weight: 600;
                color: #333333;
                span{
                    color: #ff7800;
                }
            }
            .tips-container {
                background-color: #ffffff;
                border-radius: 10px;
                padding: 16px 18px;
                margin: 0 12px;
                min-height: 113px;
                .name {
                    font-size: 16px;
                    font-weight: 600;
                    color: #333333;
                }
                .classify {
                    font-size: 14px;
                    font-weight: 600;
                    color: #333333;
                }
                .content {
                    font-size: 14px;
                    line-height: 24px;
                    color: #333333;
                }
            }
            .operate-container {
                .operate+.operate {
                    margin-left: 46px;
                }
                .operate {
                    width: 120px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background-color: #0a2240;
                    border-radius: 20px;
                    cursor: pointer;
                    font-size: 14px;
                    color: #ffffff;
                    &.yellow {
                        background-color: #ff9600;
                    }
                }
            }
        }

    }
}
</style>
